import axiosInstance from './axiosInstance';

/**
 * API calls for the My Account page.
 *
 * Endpoints:
 *   GET    /api/account            → load account data (both tabs)
 *   PUT    /api/account/profile    → save profile (name, phone)
 *   PUT    /api/account/password   → change password
 *   PUT    /api/account/settings   → save preferences (notifications, appearance, etc.)
 */

export const getAccountApi = async () => {
    const response = await axiosInstance.get('/account');
    return response.data;
};

export const updateProfileApi = async (data) => {
    // data: { firstName, lastName, phone }
    const response = await axiosInstance.put('/account/profile', data);
    return response.data;
};

export const changePasswordApi = async (data) => {
    // data: { currentPassword, newPassword, confirmNewPassword }
    const response = await axiosInstance.put('/account/password', data);
    return response.data;
};

export const updateSettingsApi = async (data) => {
    // data: { notifications: { email, push, sms }, appearance }
    const response = await axiosInstance.put('/account/settings', data);
    return response.data;
};